module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-winter-2200.e221b6df.svg";